/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import * as Yup from "yup";

/**
 * Validation Schema for the Terms and Conditions Modal
 */
export const termsAndConditionsSchema = Yup.object().shape({
  termsAccepted: Yup.boolean().oneOf([true], "Please accept the terms and conditions"),
  privacyPolicyAccepted: Yup.boolean().oneOf([true], "Please accept the privacy policy"),
  rulesAccepted: Yup.boolean().oneOf([true], "Please accept the TraceX rules"),
});
